import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UISideNav from 'UIComponents/nav/UISideNav';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';

function FilterSideNav(_ref) {
  let {
    name,
    options,
    value
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["name", "options", "value"]);

  return /*#__PURE__*/_jsx(UISideNav, Object.assign({}, rest, {
    value: value,
    children: options.map(({
      href,
      text,
      value: optionValue
    }) => /*#__PURE__*/_jsx(UISideNavItem, {
      "data-test-id": `filter-nav-item::${name}::${optionValue}`,
      href: href,
      title: text,
      value: optionValue
    }, `${name}-${optionValue}`))
  }));
}

export default FilterSideNav;